import React, { useEffect } from 'react';
import { useAppDel, useAppList, useAppPost, useAppPut } from '../../zustand/requests';

import { Button, Card, Col, Form, Input, Popconfirm, Row, Table, Typography } from 'antd';
import { DeleteOutline, PlayOutline } from 'antd-mobile-icons';

const FormPart = ({ flashcard, onChange }) => {
  const appPost = useAppPost();
  const appList = useAppList();
  const [form] = Form.useForm();

  return (
    <Card size='small'>
      <Form layout='vertical'
        form={form}
        onFinish={(e) => {
          console.log(e)
          appPost.execute({
            data: e,
            onSuccess: () => {
              form.resetFields();
              appList.execute({ force: true });
              appPost.clean()
            }
          })
        }}

      >
        <Row gutter={[10, 10]}>
          <Col span={10}>
            <Form.Item label="name" name={"name"}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item label="subdomain" name={"subdomain"}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label=" ">
              <Button block ghost type='primary' htmlType='submit'>Add</Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}


function EditorPage() {

  const appList = useAppList();
  const appPut = useAppPut();
  const appPost = useAppPost();
  const appDel = useAppDel();
  // const editFlashcard = useEditFlashcard();
  // const generateAudio = useGenerateAudio();

  useEffect(() => {
    appList.execute();
  }, [])




  return (
    <div>
      <FormPart />

      <Table
        size='small'
        loading={appList.loading || appPut.loading || appPost.loading}
        pagination={false}
        columns={[
          {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (name, { id }) => <div>
              <Typography.Text editable={{
                onChange: (e) => {
                  appPut.execute({
                    data: { name: e },
                    params: { id },
                    onSuccess: () => {
                      appPut.clean()
                      appList.execute({ force: true });
                    }
                  })
                }
              }}>
                {name}
              </Typography.Text>
            </div>,
          },
          {
            title: 'SubDomain',
            dataIndex: 'subdomain',
            key: 'subdomain',
            render: (name, { id }) => <div>
              <Typography.Text editable={{
                onChange: (e) => {
                  appPut.execute({
                    data: { subdomain: e },
                    params: { id },
                    onSuccess: () => {
                      appPut.clean()
                      appList.execute({ force: true });
                    }
                  })
                }
              }}>
                {name}
              </Typography.Text>
            </div>,
          }, {
            title: "Actions",
            dataIndex: "id",
            key: "actions",
            render: (id) => <div>
              <Popconfirm
                title="Are you sure to delete this app?"
                onConfirm={() => {
                  appDel.execute({
                    params: { id },
                    onSuccess: () => {
                      appDel.clean()
                      appList.execute({ force: true });
                    }
                  })
                }}
                okText="Yes"
                cancelText="No"
              >
                <Button danger type='link' loading={appDel.loading}><DeleteOutline /></Button>
              </Popconfirm>
            </div>
          }
        ]}
        dataSource={appList.data || []}
      />
    </div >
  )
}

export default EditorPage